/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { StartDate } from './';
import {
    StartDateFromJSON,
    StartDateFromJSONTyped,
    StartDateToJSON,
} from './';
import type { StartDateType } from './';
import {
    StartDateTypeFromJSON,
    StartDateTypeFromJSONTyped,
    StartDateTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ChosenStartDate
 */
export interface ChosenStartDate extends StartDate {
    /**
     * 
     * @type {Date}
     * @memberof ChosenStartDate
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof ChosenStartDate
     */
    flexibility: ChosenStartDateFlexibilityEnum;
}


/**
 * @export
 */
export const ChosenStartDateFlexibilityEnum = {
    NotFlexible: 'NOT_FLEXIBLE',
    MoreOrLess2Days: 'MORE_OR_LESS_2_DAYS',
    MoreOrLess1Week: 'MORE_OR_LESS_1_WEEK',
    MoreOrLess1Month: 'MORE_OR_LESS_1_MONTH'
} as const;
export type ChosenStartDateFlexibilityEnum = typeof ChosenStartDateFlexibilityEnum[keyof typeof ChosenStartDateFlexibilityEnum];


/**
 * Check if a given object implements the ChosenStartDate interface.
 */
export function instanceOfChosenStartDate(value: object): value is ChosenStartDate {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('flexibility' in value) || value['flexibility'] === undefined) return false;
    return true;
}

export function ChosenStartDateFromJSON(json: any): ChosenStartDate {
    return ChosenStartDateFromJSONTyped(json, false);
}

export function ChosenStartDateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChosenStartDate {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...StartDateFromJSONTyped(json, ignoreDiscriminator),
        'date': (new Date(json['date'])),
        'flexibility': json['flexibility'],
    };
}

export function ChosenStartDateToJSON(value?: ChosenStartDate | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...StartDateToJSON(value, true),
        'date': ((value['date']).toISOString().substring(0,10)),
        'flexibility': value['flexibility'],
    };
}

